<template>
  <div :class="['productList', { inApp: $root.$data.isApp|| this.$root.miniprogram}]">
    <common-title titleName="课程列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="tabs">
      <div
        v-for="(item, index) in tab"
        @click="seleted = index"
        :key="index"
        :class="{ active: seleted == index }"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :offset="20"
        v-if="seleted == 0"
        @load="onLoad"
      >
        <ul class="courseList">
          <HotCourseCard v-for="(item, keys) in productList" :key="keys" :item="item" />
          <EmptyData :emptyName="'noProductList'" v-if="!productList.length" />
        </ul>
      </van-list>
      <ul class="courseList" v-else>
        <CombinationCard v-for="(item, keys) in packageList" :key="keys" :item="item" />
        <EmptyData :emptyName="'noProductList'" v-if="!packageList.length" />
      </ul>
      <EmptyData :emptyName="'noProductList'" v-if="!packageList.length && !productList.length" />
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';

// eslint-disable-next-line import/no-cycle
import { reqCombinationlist } from '@/api/combination';
import { resetProductData, resetCoursePackage } from '@/utils/tools';
import { mapState } from 'vuex';
import { reqProducts, reqProductList } from '@/api/home';
import Loading from '../../components/loading/loading.vue';

export default {
  components: {
    CommonTitle,
    CombinationCard,
    EmptyData,
    Loading,
    Foot,
    HotCourseCard,
  },
  data() {
    return {
      productList: [],
      packageList: [],
      loading: false,
      listEmpty: false, // 在loading时不显示缺省页
      currentPage: 1,
      totalPages: 0, // 总页数
      loading: false,
      finished: false,
      refreshing: false,
      stopPropagation: true,
      tab: [
        {
          name: '单品',
        },
        {
          name: '套餐',
        },
      ],
      seleted: 0,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    this.getCombinationlist();
    this.getCourse(this.currentPage, 12);
  },
  mounted() {
    const ua = navigator.userAgent.toLowerCase();
    const isOhos = /ohos/.test(ua);
    if (isOhos) {
      window?.ohos?.setWindowTitle('课程列表');
      window?.harmony?.setTitle('课程列表');
    } else if (document.title) {
      document.title = '课程列表';
    }
  },
  methods: {
    async getCombinationlist() {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const { packageIds } = this.$route.query;
      const allPackageIds = packageIds?.split(',');
      const res = allPackageIds?.length ? await reqCombinationlist(0, endPoint, allPackageIds) : {};
      if (res?.code === 0 && res?.data?.length) {
        this.packageList = resetCoursePackage(res.data || []);
      }
    },
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      const { productionFitType } = this.$route.query;
      if (Number(productionFitType) === 2) {
        this.finished = true;
        return;
      }
      this.downLoad = true;
      if (this.productList.length >= this.totalPages) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.currentPage += 1;
        this.getCourse(this.currentPage, 12);
      }
    },
    // 请求产品列表
    async getCourse(pageNum, pageSize) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const { productionFitType, productIds, productCategoryIds, packageFitType, packageIds } =
        this.$route.query;
      let res = [];
      if (Number(productionFitType) === 2) {
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        res = await reqProducts(productIds.split(','), endPoint);
        if (res.code === 0 && res.data) {
          if (this.refreshing) {
            this.productList = [];
          }
          this.refreshing = false;
          this.loading = false;
          this.productList = [...this.productList, ...resetProductData(res.data || [])];
          this.totalPages = res.data.length;
          if (!res.data.length) {
            this.listEmpty = true;
          }
        } else {
          this.listEmpty = true;
          this.refreshing = false;
        }
      } else {
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        res = await reqProductList({
          productCategoryIds: productCategoryIds.split(','),
          pageNum,
          pageSize,
          endPoint,
          company: 0,
          isShow: 1,
        });
        if (res.code === 0 && res.data) {
          // 下拉加载时不执行
          if (!this.downLoad) {
            if (this.refreshing) {
              this.productList = [];
            }
          }
          this.refreshing = false;
          this.loading = false;
          this.productList = [...this.productList, ...resetProductData(res.data.data || [])];
          if (!res.data.data.length) {
            this.listEmpty = true;
          }
          this.totalPages = res.data.total;
        } else {
          this.listEmpty = true;
          this.refreshing = false;
        }
      }
      this.$toast.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}
.tabs {
  position: fixed;
  top: 100px;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 83px;
  background: #fff;
  div {
    position: relative;
    width: 50%;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    text-align: center;
  }
  div:last-child {
    border-left: 1px solid #e1e1e1;
  }
  div.active {
    color: #ff7f41;
    font-size: 29px;
  }
  div.active::after {
    position: absolute;
    right: 0;
    bottom: -30px;
    left: 0;
    display: block;
    width: 29px;
    height: 7px;
    margin: 0 auto;
    background: #ff7f41;
    border-radius: 3px;
    content: '';
  }
}
.productList {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 183px 36px 0 36px;
  background: #fefeff;
  &.inApp {
    padding-top: 110px;
    padding-bottom: 0;
    .tabs {
      top: 0;
    }
  }
  .content {
    height: 100%;
  }
  .courseList {
    box-sizing: border-box;
    width: 100%;
    min-height: 98px;
    padding: 20px 0;
    background: #fff;
  }

  .courseList > li {
    position: relative;
    width: 686px;
    // height: 3.06px;
    // border: 1px solid red;
    // display: flex;
    // flex-wrap: nowrap;
    margin: 0 auto;
    margin-bottom: 25px;
    padding: 0.32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(240, 244, 244, 1);
    opacity: 1;
    .liveImg {
      position: absolute;
      top: 0;
      right: 0;
      width: 140px;
      height: 50px;
      border-radius: 0 16px 0 32px;
    }
  }
}
</style>
